import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import HNavMenuGroup from './HorizontalNavMenuGroup.vue';
import HNavMenuItem from './HorizontalNavMenuItem.vue';
export default {
  props: {
    header: {
      type: Object,
      requried: true
    },
    openOnHover: {
      type: Boolean,
      default: true
    }
  },
  components: {
    HNavMenuGroup: HNavMenuGroup,
    HNavMenuItem: HNavMenuItem
  },
  data: function data() {
    return {
      showChildren: false,
      isHovered: false,
      dropRight: false
    };
  },
  computed: {
    isHeaderActive: function isHeaderActive() {
      var _this = this;

      var path = this.$route.fullPath;
      var active = false;
      var routeParent = this.$route.meta ? this.$route.meta.parent : undefined;
      this.header.items.forEach(function (item) {
        // If item is group
        if (item.submenu) {
          if (_this.checkGrpChildrenActive(item)) {
            active = true;
          }
        } else if (item.url) {
          if (path == item.url || routeParent == item.slug) {
            active = true;
          }
        }
      });
      return active;
    }
  },
  watch: {
    showChildren: function showChildren() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.showChildren) {
          var dd = _this2.$refs.headerDropdown;

          if (dd.getBoundingClientRect().left + dd.offsetWidth - (window.innerWidth - 16) >= 0) {
            _this2.dropRight = true;
          }
        }
      });
    }
  },
  methods: {
    checkGrpChildrenActive: function checkGrpChildrenActive(group) {
      var _this3 = this;

      var path = this.$route.fullPath;
      var active = false;
      var routeParent = this.$route.meta ? this.$route.meta.parent : undefined;

      if (group.submenu) {
        group.submenu.forEach(function (item) {
          if ((path == item.url || routeParent == item.slug) && item.slug) {
            active = true;
          } else if (item.submenu) {
            _this3.checkGrpChildrenActive(item) ? active = true : null;
          }
        });
      }

      return active;
    },
    hovered: function hovered() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.isHovered = val;

      if (this.openOnHover) {
        val ? this.showChildren = true : this.showChildren = false;
      }
    }
  }
};